import { Array, Record } from 'effect'

import type { CoreViewWithMetric } from '../../../schemas/View.ts'

type Mapper = Record<string, CoreViewWithMetric>

export class ViewSearcher {
  private readonly mapper: Mapper
  public readonly views: CoreViewWithMetric[]

  public constructor(views: CoreViewWithMetric[]) {
    this.views = views
    this.mapper = Record.fromIterableBy(Array.reverse(views), (x) => x.id)
  }

  public searchView(viewId: string): CoreViewWithMetric | undefined {
    return this.mapper[viewId]
  }
}
